import { render } from "./productList.vue?vue&type=template&id=234565c0"
import script from "./productList.vue?vue&type=script&lang=js"
export * from "./productList.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/brandProduct/productList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "234565c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('234565c0', __exports__)) {
    console.log('reload')
    api.reload('234565c0', __exports__)
  }
  
  module.hot.accept("./productList.vue?vue&type=template&id=234565c0", () => {
    console.log('re-render')
    api.rerender('234565c0', render)
  })

}


export default __exports__